// extracted by mini-css-extract-plugin
export var categorySizeCompact = "uiehj";
export var categorySizeFull = "noOo5";
export var categorySizeFullOrMedium = "rk3E8";
export var categorySizeMediumOrCompact = "ebw0l";